import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme: Theme) => ({
  container: {},
  usersLength: {
    padding: theme.spacing(0.5),
    backgroundColor: "#F2F2F2",
    fontWeight: "bold",
    fontSize: "18px",
    marginLeft: theme.spacing(2),
    borderRadius: theme.spacing(1),
  },
  newAthleteButtonContainer: {
    marginLeft: "auto",
    [theme.breakpoints.down("sm")]: {
      marginLeft: "0",
    },
  },
  mobileAthleteCardContainer: {
    marginTop: theme.spacing(2),
  },
  select: {
    borderRadius: theme.spacing(1),
    marginLeft: theme.spacing(1),
  },
  tabsContainer: {
    width: "fit-content",
    typography: "body1",
    backgroundColor: "#F2F2F2",
    borderRadius: theme.spacing(1),
  },
  tabIndicator: {
    backgroundColor: "black",
    color: "white",
    borderRadius: theme.spacing(1),
  },
  tab: {
    width: theme.spacing(40),
    maxWidth: theme.spacing(40),
    borderRadius: theme.spacing(1),
    backgroundColor: "transparent",
    zIndex: 1,
    "&[aria-selected=true]": {
      color: "white",
    },
  },
  tabControlsContainer: {
    backgroundColor: "#F2F2F2",
    overflow: "hidden",
    borderRadius: theme.spacing(1),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
}));

export default useStyles;
